import { useEffect, useState } from 'react';
import { PixelIcon } from '@/presentation/icons/PixelIcon';

const SEQ = [
  'ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
  'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight',
  'KeyB', 'KeyA',
];

export function KonamiCat() {
  const [active, setActive] = useState(false);

  useEffect(() => {
    let idx = 0;
    const onKey = (e: KeyboardEvent): void => {
      if (e.code === SEQ[idx]) {
        idx++;
        if (idx === SEQ.length) {
          setActive(true);
          idx = 0;
          setTimeout(() => setActive(false), 8000);
        }
      } else {
        idx = e.code === SEQ[0] ? 1 : 0;
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  if (!active) return null;
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        bottom: 8,
        left: -64,
        zIndex: 999,
        animation: 'catWalk 8s linear',
        pointerEvents: 'none',
      }}
    >
      <PixelIcon name="play" size={48} color="#ffd6b3" />
      <style>{`@keyframes catWalk { from { left: -64px; } to { left: 100vw; } }`}</style>
    </div>
  );
}
